import { state } from "../variables/state"
import { processFunds } from "../adf/funds"
import { showPage } from "../ui/page"
import { sameDomain } from "../lib/utils"

export const getFunds = (handlerURL) => {
  const onSuccess = (data) => {
    window.funds = data
    // console.log(data)
    showPage()
    localStorage.setItem('funds', JSON.stringify(data))
    processFunds(data)
  }

  const onFail = (errors) => {
    console.log(errors)
  }

  const useBBISCustomHandler = (url) => {
    fetch(url)
      .then(function(response) {
        if (response.ok) {
          return response.json()
        } else {
          return Promise.reject(response)
        }
      })
      .then(function(data) {
        onSuccess(data)
      }).catch(function(err) {
        onFail(err)
      })
  }

  if (state.isReturning && localStorage.getItem('funds')) {
    showPage()
    processFunds(JSON.parse(localStorage.getItem('funds')))
  } else if (handlerURL && sameDomain(handlerURL)) {
    useBBISCustomHandler(handlerURL)
  }
}